import { v4 } from "uuid";
import {
  ColumnDescriptor,
  Gate,
  Relation,
  RelationType,
  ValueShape,
  WhereItem,
} from "../../globalTypes";

export const getWhereItemEmptyValue = (): ValueShape => ({
  numberVal: null,
  stringVal: null,
  booleanVal: null,
  dateVal: null,
  dateValRange: null,
  dateValDynamic: null,
  targetColumnVal: null,
  selectVal: null,
});

export const createColumnDescriptor = (
  values: Partial<ColumnDescriptor>
): ColumnDescriptor => ({
  tableIdentifier: null,
  columnIdentifier: null,
  templateIdentifier: null,
  ...values,
});

const createDefaultRelation = (type: RelationType): Relation => ({
  type,
  operator: "eq",
});

export const createWhereItem = (
  type: RelationType,
  props?: Partial<WhereItem>
): WhereItem => ({
  id: v4(),
  gate: Gate.And,
  source: createColumnDescriptor({}),
  relation: createDefaultRelation(type),
  searchValue: getWhereItemEmptyValue(),
  children: [],
  disabled: false,
  isList: false,
  ...props,
});
